import { createUseTrackScreen } from '@bluecodecom/tracking';

import { ScreenName, TrackingEvents, trackingService } from '../../service';

/**
 * Reports a displayed screen twice — the catalogued universal `screen_displayed`
 * and this app's legacy `Handyparken: <Screen>: Opened` — for as long as the
 * migration needs both (catalog rule `dual-fire`).
 *
 * The behaviour, including suppressing *both* events on a nullish screen name,
 * lives in `libs/tracking`; see `createUseTrackScreen` there. All this file does
 * is bind handyparken's service and screen vocabulary to it.
 */
const useTrackScreen = createUseTrackScreen<ScreenName, TrackingEvents>(
  trackingService,
);

export default useTrackScreen;
